export default "__VITE_ASSET__q$2ahIxs__"